// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
//
// Function exports are real declarations (not reference copies) — see the
// note in hooks/useAuth.ts for why: automocking (`vi.mock(path)` with no
// factory) does not reliably intercept a reference-copy or pass-through
// re-export. `api`/`csrfClient` (axios instances, not functions) and
// `appUpdateRequiredRef` (a plain object) are plain re-exports for a
// different reason: a reference-copy const snapshot (`export const X =
// ns.X`) can read as undefined when this module and a direct
// @livingsyncs/ui import land in the same module graph — see the
// formErrorHandler.ts note. vi.spyOn(apiClient.default, "get") still works
// fine on a live-binding re-export, same shared object underneath.
import * as _apiClientModule from "@livingsyncs/ui";

export {
  api,
  api as default,
  csrfClient,
  appUpdateRequiredRef,
} from "@livingsyncs/ui";

export async function fetchCsrfToken() {
  return _apiClientModule.fetchCsrfToken();
}
export function clearCsrfToken() {
  return _apiClientModule.clearCsrfToken();
}
export async function logoutAndSignOut() {
  return _apiClientModule.logoutAndSignOut();
}
export function __resetAuthLogoutLatchForTests() {
  return _apiClientModule.__resetAuthLogoutLatchForTests();
}
